module.exports = __webpack_public_path__ + "img/logo_roses.f41c1ba4.png";